import React from 'react';
import './Loader.css';

interface LoaderProps {
  size?: 'sm' | 'md' | 'lg';
  label?: string;
  className?: string;
}

export const Loader: React.FC<LoaderProps> = ({ size = 'md', label, className = '' }) => (
  <div className={`loader-container${className ? ` ${className}` : ''}`}>
    <div className={`loader-spinner loader-spinner--${size}`} />
    {label && <span className="loader-label">{label}</span>}
  </div>
);

export default Loader;
